import { report } from '../report';

export type Constructor<T> = { new (...args: any[]): T };

export function unexpectedValue(value: never, throwError: boolean = true, valueToPrint?: unknown) {
    const message = 'Unexpected value: ' + (valueToPrint !== undefined ? valueToPrint : value);
    if (throwError) throw new Error(message);
    report(message, { once: true });
}

export type FilteredKeys<Type, FilterType> = {
    [Key in keyof Type]: Type[Key] extends FilterType ? Key : never;
}[keyof Type];

export type Immutable<T> = T extends Function | boolean | number | string | null | undefined
    ? T
    : T extends Array<infer U>
    ? ReadonlyArray<Immutable<U>>
    : T extends Map<infer K, infer V>
    ? ReadonlyMap<Immutable<K>, Immutable<V>>
    : T extends Set<infer S>
    ? ReadonlySet<Immutable<S>>
    : T extends Date
    ? ReadonlyDate
    : { readonly [P in keyof T]: Immutable<T[P]> };

export type ReadonlyDate = Pick<Date, 'getTime' | 'getDate' | 'toString' | 'toTimeString'>;

export type tEasing = (k: number) => number;
export type KeyOf<T> = keyof T;

export type Condition<Parameters> = (params: Parameters) => boolean;

export function isUndefined(value: unknown): value is undefined {
    return typeof value === 'undefined';
}

export function isNumber(value: unknown): value is number {
    return typeof value === 'number';
}

export function isNull(value: unknown): value is null {
    return value === null;
}

export const never = (a: never): void => void 0;
